import { parse, stringify } from "qs";
import { SHARE_LINKS } from "config/constants";

/**
 * Accepts headline and permalink and returns formatted share links.
 * @param {string} permalink 
 * @param {string} headline 
 * @returns {Array<{ name: string, description: string, url: string}>}
 */
export default function createShareLinks(permalink, headline) {
  return SHARE_LINKS.map((shareLink) => {
    // share links strings require a series of transforms
    let url, rest, hash;
    let params = {};
    // 1. split the post's permalink, grabbing the first hash
    [ rest, hash ] = permalink.split("#", 2);
    // 2. then split it again to get any query params
    [ url, params ] = rest.split("?", 2);
    // 3. concatenate original permalink params with analytics params
    const newParams = { ...parse(params), ...shareLink.ANALYTICS_PARAMS };
    // 4. encode the string, appeneding any permalink hashes at the end so they still work
    const axiosUrl = encodeURIComponent(`${url}?${stringify(newParams)}${ hash ? `#${hash}` : "" }`);
    // 5. set additional parameters specific to social platform like LinkedIn and Twitter
    let socialParams = { ...shareLink.SOCIAL_PARAMS };
    if (shareLink.NAME === "twitter") socialParams.text = headline;
    // 6. finally, concatenate the social share link with the encoded url and any social platform-specific parameters
    const socialUrl = `${shareLink.URL}?${shareLink.URL_PARAM}=${axiosUrl}${ shareLink.SOCIAL_PARAMS ? `&${stringify(socialParams)}` : "" }`;

    return {
      name: shareLink.NAME,
      description: shareLink.DESCRIPTION,
      url: socialUrl,
    };
  });
}
